// Compass (#191) — gate predicate for the header "🧭 Compass" data-browser
// button. Compass is the in-app MongoDB-Compass-style data browser for the
// Convex mirror AND the live Mongo collections (read-only in Phase 1).
//
// Returns true ONLY when the user is logged in AND their Users document
// carries `compassAccess: true` (strict equality — undefined, null, false,
// or any other truthy non-true value all hide the button).
//
// Why strict `=== true` (same rationale as canAccessTimeMachine /
// canAccessDashboard):
//   - The seed migration (dbtools/src/mutations/users-add-compassAccess.mjs)
//     stamps `false` on every Users doc. Admins flip selected users to `true`
//     in MongoDB Compass to grant access. The field is purely manual — code
//     never writes it.
//   - Treating any-truthy as access would mean a future schema change that
//     stores e.g. a permission level string ("read", "admin") accidentally
//     opens the gate. Strict-true documents the intent.

export function canAccessCompass(mongoUser, tsUserDocument) {
  return Boolean(mongoUser) && tsUserDocument?.compassAccess === true;
}
